/**
 * Kopiuje tekst do schowka.
 * @param text Tekst do skopiowania
 */
export async function copyToClipboard(text: string) {
	if (navigator.clipboard) {
		await navigator.clipboard.writeText(text);
		return;
	}

	const el = document.createElement('textarea');
	el.value = text;
	document.body.appendChild(el);
	el.select();
	document.execCommand('copy');
	document.body.removeChild(el);
}

export function shareUrl(url: string, title: string) {
	if (window.navigator.share && window.innerWidth < 768) {
		window.navigator.share({ title, text: '', url });
		return true;
	}
	return false;
}

export function downloadUrl(url: string, filename: string) {
	const link = document.createElement('a');
	link.href = url;
	if (filename) {
		link.download = filename;
	}
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export function GetMailboxUrl(s: string) {
	if (!s || s.indexOf('@') === -1) { return ''; }
	s = s.split('@')[1];

	const list = {
		'wp.pl': 'profil.wp.pl',
		'wp.eu': 'profil.wp.pl',
		'poczta.wp.pl': 'profil.wp.pl',
		'xl.wp.pl': 'profil.wp.pl',
		'gmail.com': 'gmail.com',
		'googlemail.com': 'gmail.com',
		'o2.pl': 'poczta.o2.pl',
		'prokonto.pl': 'poczta.o2.pl',
		'go2.pl': 'poczta.o2.pl',
		'tlen.pl': 'poczta.o2.pl',
		'interia.pl': 'poczta.interia.pl',
		'interia.eu': 'poczta.interia.pl',
		'interia.com': 'poczta.interia.pl',
		'onet.pl': 'konto.onet.pl',
		'op.pl': 'konto.onet.pl',
		'buziaczek.pl': 'konto.onet.pl',
		'amorki.pl': 'konto.onet.pl',
		'poczta.onet.eu': 'konto.onet.pl',
		'poczta.onet.pl': 'konto.onet.pl',
		'onet.eu': 'konto.onet.pl',
		'autograf.pl': 'konto.onet.pl',
		'vip.onet.pl': 'konto.onet.pl',
		'spoko.pl': 'konto.onet.pl',
		'onet.com.pl': 'konto.onet.pl',
		'vp.pl': 'konto.onet.pl',
		'adres.pl': 'konto.onet.pl',
		'opoczta.pl': 'konto.onet.pl',
		'outlook.com': 'outlook.live.com',
		'hotmail.com': 'outlook.live.com',
		'gazeta.pl': 'oauth.gazeta.pl',
		'g.pl': 'oauth.gazeta.pl',
		'yahoo.com': 'login.yahoo.com',
		'yahoo.pl': 'login.yahoo.com',
		'yahoo.co.uk': 'login.yahoo.com',
		'icloud.com': 'icloud.com',
		'neostrada.pl': 'webmail.neostrada.pl',
		'mail.ru': 'mail.ru',
		'bk.ru': 'mail.ru',
		'inbox.ru': 'mail.ru',
		'yandex.ru': 'passport.yandex.ru',
		'ukr.net': 'mail.ukr.net',
		'post.pl': 'login.poczta.home.pl',
		'home.pl': 'login.poczta.home.pl',
		'data.pl': 'login.poczta.home.pl',
		'list.pl': 'login.poczta.home.pl',
		'rambler.ru': 'games.rambler.ru',
		'orange.pl': 'poczta.orange.pl',
		'int.pl': 'int.pl',
		'gmx.de': 'gmx.de',
	};

	return list[s] ? (`//${list[s]}`) : 'Nie znaleziono serwisu pocztowego dla tego adresu email';
}
